import React from "react";
import classNames from "classnames/dedupe";
import {
  AdidasIcon,
  AsicsIcon,
  NakamuraIcon,
  NewBalanceIcon,
  NikeIcon,
  PumaIcon,
  ReebokIcon,
  SkechersIcon,
  TafIcon,
  TnfIcon,
  ErreaIcon,
  AtkIcon,
  ConverseIcon,
  EverlastIcon,
  FilaIcon,
  HurleyIcon,
  JordanIcon,
  MizunoIcon,
  SaetaIcon,
  SauconyIcon,
} from "../../../icons";
import Link, { ILinkProps } from "../../ActionsSelectors/Link/Link";

const iconsMapping = {
  Adidas: AdidasIcon,
  Nike: NikeIcon,
  Asics: AsicsIcon,
  Nakamura: NakamuraIcon,
  NewBalance: NewBalanceIcon,
  Puma: PumaIcon,
  Reebok: ReebokIcon,
  Skechers: SkechersIcon,
  Taf: TafIcon,
  Tnf: TnfIcon,
  Errea: ErreaIcon,
  Atk: AtkIcon,
  Converse: ConverseIcon,
  Everlast: EverlastIcon,
  Fila: FilaIcon,
  Hurley: HurleyIcon,
  Jordan: JordanIcon,
  Mizuno: MizunoIcon,
  Saeta: SaetaIcon,
  Saucony: SauconyIcon,
};

export type TBrand = keyof typeof iconsMapping;
export interface IBrandTileProps<LinkType> extends ILinkProps<LinkType> {
  customImage?: JSX.Element;
  customBrandTitle?: string;
  type?: TBrand;
}

const getIonComponent = (type: string) => {
  return iconsMapping[type];
};

const getBrandName = (type: string) => {
  return type?.replace("_", " ");
};

function BrandTile<LinkType>({
  customImage,
  customBrandTitle,
  type,
  classes,
  linkParams,
}: IBrandTileProps<LinkType>): JSX.Element {
  const Icon = getIonComponent(type);

  const linkClasses = classNames(classes?.root, "brand-tile");

  return (
    <Link key={type} classes={{ root: linkClasses }} {...(linkParams || {})}>
      <>
        <div className="brand-tile__rec">
          <div>{customImage || (Icon && <Icon />)}</div>
        </div>
        <div className="brand-tile__desc">
          {customBrandTitle || getBrandName(type)}
        </div>
      </>
    </Link>
  );
}

export default BrandTile;
